import { cn } from '@growtherapy/sprout-ui';

import { NoAccessVariant } from '../../session/controls/NoAccess';
import { BlockedPermissionDescription } from '../BlockedPermissionDescription';

export type WithPassThroughProps<P = unknown> = P & {
  className?: string;
  noAccessVariant?: NoAccessVariant;
};

export function BlockedPermissionMessage({
  className,
  isMobile,
  isSafari,
  isDarkTheme,
  noAccessVariant,
}: WithPassThroughProps<{
  isMobile: boolean;
  isSafari: boolean;
  isDarkTheme: boolean;
}>) {
  return (
    <div
      className={cn(
        'flex flex-col gap-6 w-full rounded border border-neutral-700 bg-neutral-200 p-4 rebrand:bg-surface-inverseEmphasis rebrand:border-border-default',
        className,
      )}
    >
      <BlockedPermissionDescription
        isMobile={isMobile}
        isSafari={isSafari}
        isDarkTheme={isDarkTheme}
        noAccessVariant={noAccessVariant}
      />
    </div>
  );
}
